import { render, staticRenderFns } from "./TableConfirmRemind.vue?vue&type=template&id=7ca6653e"
import script from "./TableConfirmRemind.vue?vue&type=script&lang=js"
export * from "./TableConfirmRemind.vue?vue&type=script&lang=js"
import style0 from "./TableConfirmRemind.vue?vue&type=style&index=0&id=7ca6653e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports